<template>
  <div>
    <!--筛选栏-->
    <Row type="flex" :space-x="10" class="margin-right-left padding-top" align="middle">
      <Cell>
        <Select v-model="filter.direction" :allow-clear="true" style="width:120px" placeholder="单据方向">
          <Option value="IN">入库单</Option>
          <Option value="OUT">出库单</Option>
        </Select>
      </Cell>
      <Cell>
        <DatePicker v-model="filter.startDate" format="yyyy-MM-dd" placeholder="开始日期" style="width:140px"></DatePicker>
      </Cell>
      <Cell>
        <DatePicker v-model="filter.endDate" format="yyyy-MM-dd" placeholder="结束日期" style="width:140px"></DatePicker>
      </Cell>
      <Cell>
        <Button color="primary" @click="onSearch">查询</Button>
      </Cell>
      <Cell>
        <Button @click="onReset">重置</Button>
      </Cell>
      <Cell>
        <Button color="success" @click="openEditor('IN')">新增入库</Button>
      </Cell>
      <Cell>
        <Button color="warning" @click="openEditor('OUT')">新增出库</Button>
      </Cell>
      <Cell>
        <Button @click="goCheck">新增盘点</Button>
      </Cell>
      <Cell>
        <Button color="primary" @click="openReceipt">新增收款单</Button>
      </Cell>
      <Cell>
        <Button color="primary" @click="doGenerate" :disabled="!selectedIds.length">生成凭证</Button>
      </Cell>
      <Cell>
        <Button @click="doExport">导出</Button>
      </Cell>
    </Row>

    <!--列表-->
    <div class="h-panel-body padding-top">
      <Table :datas="list" :border="true" :loading="loading" multiSelect @selection-change="onSelect">
        <TableItem type="check" width="50" :prop="'id'"></TableItem>
        <TableItem title="单据编号" prop="code" :width="170"></TableItem>
        <TableItem title="单据日期" prop="billDate" :width="110"></TableItem>
        <TableItem title="单据类型" prop="billTypeName" :width="120"></TableItem>
        <TableItem title="来源" prop="source" :width="100"></TableItem>
        <TableItem title="往来单位" prop="supplierName" :width="160"></TableItem>
        <TableItem title="总金额" align="right" :width="120">
          <template slot-scope="{data}">{{ money(data.amount) }}</template>
        </TableItem>
        <TableItem title="总数量" align="right" :width="100">
          <template slot-scope="{data}">{{ num(data.totalQty) }}</template>
        </TableItem>
        <TableItem title="凭证状态" :width="110" align="center">
          <template slot-scope="{data}">
            <Tag :color="data.voucherStatus === 2 ? 'success' : 'warning'">{{ data.voucherStatusText }}</Tag>
          </template>
        </TableItem>
        <TableItem title="操作" :width="110" align="center">
          <span slot-scope="{data}" class="link" @click="openEdit(data)">编辑</span>
          <span slot-scope="{data}" class="link danger" @click="doDelete(data)">删除</span>
        </TableItem>
      </Table>
      <Pagination :page="filter.page" size="small" :total="total" @change="onPage" class="margin-top text-right"></Pagination>
    </div>

    <!--单据编辑弹窗-->
    <Modal v-model="modal" :title="(form.direction === 'IN' ? '新增入库' : '新增出库')" width="960" :mask-closable="false">
      <Form :label-width="90" :model="form">
        <Row :gutter="10">
          <Cell>
            <FormItem label="单据日期">
              <DatePicker v-model="form.billDate" format="yyyy-MM-dd"></DatePicker>
            </FormItem>
          </Cell>
          <Cell>
            <FormItem label="单据类型">
              <Select v-model="form.billTypeId" filterable>
                <Option v-for="t in filteredBillTypes" :value="t.id" :key="t.id">{{ t.name }}</Option>
              </Select>
            </FormItem>
          </Cell>
          <Cell>
            <FormItem label="往来单位">
              <Select v-model="form.supplierId" filterable @change="onSupplierChange">
                <Option v-for="s in suppliers" :value="s.id" :key="s.id">{{ s.name }}</Option>
              </Select>
            </FormItem>
          </Cell>
          <Cell>
            <FormItem label="备注">
              <input type="text" v-model="form.remark" style="width:100%">
            </FormItem>
          </Cell>
        </Row>
      </Form>

      <div class="text-right" style="margin-bottom:8px">
        <Button color="primary" size="small" @click="addDetail">添加明细</Button>
      </div>
      <Table :datas="form.details" :border="true">
        <TableItem title="序号" :width="55" align="center">
          <template slot-scope="{index}">{{ index + 1 }}</template>
        </TableItem>
        <TableItem title="存货" :width="200">
          <template slot-scope="{data}">
            <Select v-model="data.materielId" filterable @change="onMaterialChange(data)">
              <Option v-for="m in stocks" :value="m.id" :key="m.id">{{ m.name }}</Option>
            </Select>
          </template>
        </TableItem>
        <TableItem title="规格型号" prop="spec" :width="120"></TableItem>
        <TableItem title="单位" prop="unit" :width="80"></TableItem>
        <TableItem title="数量" :width="120">
          <template slot-scope="{data}">
            <input type="number" v-model.number="data.qty" @input="calcAmount(data)" style="width:100%">
          </template>
        </TableItem>
        <TableItem title="单价" :width="120">
          <template slot-scope="{data}">
            <input type="number" v-model.number="data.price" @input="calcAmount(data)" style="width:100%">
          </template>
        </TableItem>
        <TableItem title="金额" :width="120" align="right">
          <template slot-scope="{data}">{{ money(data.amount) }}</template>
        </TableItem>
        <TableItem title="操作" :width="70" align="center">
          <span slot-scope="{data,index}" class="link danger" @click="removeDetail(index)">移除</span>
        </TableItem>
      </Table>

      <div slot="bottom">
        <Button @click="modal = false">取消</Button>
        <Button color="primary" @click="doSave" :loading="saving">保存</Button>
      </div>
    </Modal>

    <!--凭证预览-->
    <Modal v-model="previewModal" title="凭证预览" width="760">
      <div v-for="(v, i) in previewList" :key="i">
        <div class="voucher-title">单据：{{ v.orderCode }}</div>
        <Table :datas="v.lines" :border="true">
          <TableItem title="摘要" prop="summary"></TableItem>
          <TableItem title="科目" prop="subjectName"></TableItem>
          <TableItem title="借方" prop="jie" align="right"></TableItem>
          <TableItem title="贷方" prop="dai" align="right"></TableItem>
        </Table>
        <div class="text-right" style="margin:10px 0">
          <Button color="primary" @click="confirmGenerate">确认生成</Button>
        </div>
      </div>
    </Modal>

    <!--新增收款单弹窗-->
    <Modal v-model="receiptModal" title="新增收款单" width="620">
      <Form label-width="100" :model="receipt">
        <FormItem label="单据日期">
          <DatePicker v-model="receipt.billDate" format="yyyy-MM-dd"></DatePicker>
        </FormItem>
        <FormItem label="收款账户">
          <Select v-model="receipt.accountId" filterable>
            <Option v-for="a in accounts" :value="a.id" :key="a.id">{{ a.name }}</Option>
          </Select>
        </FormItem>
        <FormItem label="对方单位">
          <Select v-model="receipt.supplierId" filterable @change="onReceiptSupplier">
            <Option v-for="s in suppliers" :value="s.id" :key="s.id">{{ s.name }}</Option>
          </Select>
        </FormItem>
        <FormItem label="收款金额">
          <input type="number" v-model.number="receipt.amount" style="width:100%">
        </FormItem>
        <FormItem label="摘要">
          <input type="text" v-model="receipt.summary" style="width:100%">
        </FormItem>
      </Form>
      <div slot="bottom">
        <Button @click="receiptModal = false">取消</Button>
        <Button color="primary" @click="doSaveReceipt">保存</Button>
      </div>
    </Modal>
  </div>
</template>

<script>
export default {
  name: 'InventoryBillManager',
  data() {
    return {
      filter: {direction: '', startDate: '', endDate: '', page: 1},
      list: [],
      total: 0,
      loading: false,
      selectedIds: [],
      stocks: [],
      suppliers: [],
      accounts: [],
      billTypes: [],
      modal: false,
      saving: false,
      form: this.blankForm('IN'),
      previewModal: false,
      previewList: [],
      receiptModal: false,
      receipt: {billDate: new Date(), accountId: null, supplierId: null, amount: 0, summary: ''}
    };
  },
  computed: {
    filteredBillTypes() {
      return this.billTypes.filter(t => !this.form.direction || t.direction === this.form.direction);
    }
  },
  methods: {
    blankForm(direction) {
      return {
        id: null, direction: direction || 'IN', billDate: new Date(), billTypeId: null,
        supplierId: null, supplierName: '', remark: '', details: []
      };
    },
    money(val) {
      let n = Number(val);
      return isNaN(n) ? '0.00' : n.toFixed(2);
    },
    num(val) {
      let n = Number(val);
      return isNaN(n) ? '0' : String(n);
    },
    loadOptions() {
      this.$api.pro.inventory.stocks({pageSize: 1000}).then(({data}) => {
        this.stocks = data.results || data || [];
      }).catch(() => {});
      this.$api.pro.inventory.billTypeList().then(({data}) => {
        this.billTypes = data || [];
      }).catch(() => {});
      this.$api.setting.inventorySupplier.list({page: 1, size: 500}).then(({data}) => {
        this.suppliers = data.records || data.results || data || [];
      }).catch(() => {});
      this.$api.funds.account.list().then(({data}) => {
        this.accounts = data.records || data.results || data || [];
      }).catch(() => {});
    },
    loadList() {
      this.loading = true;
      let p = {
        page: this.filter.page,
        pageSize: 20,
        direction: this.filter.direction || '',
        startDate: this.filter.startDate ? this.fmt(this.filter.startDate) : '',
        endDate: this.filter.endDate ? this.fmt(this.filter.endDate) : ''
      };
      this.$api.pro.inventory.billList(p).then(({data}) => {
        this.list = data.results || [];
        this.total = data.total || 0;
      }).finally(() => this.loading = false);
    },
    fmt(d) {
      let dt = d instanceof Date ? d : new Date(d);
      return dt.getFullYear() + '-' + String(dt.getMonth() + 1).padStart(2, '0') + '-' + String(dt.getDate()).padStart(2, '0');
    },
    onSearch() {
      this.filter.page = 1;
      this.loadList();
    },
    onReset() {
      this.filter = {direction: '', startDate: '', endDate: '', page: 1};
      this.loadList();
    },
    onPage(page) {
      this.filter.page = page;
      this.loadList();
    },
    onSelect(selection) {
      this.selectedIds = selection.map(r => r.id);
    },
    goCheck() {
      this.$router.push({name: 'InventoryCheck'});
    },
    openEditor(direction) {
      this.form = this.blankForm(direction);
      this.addDetail();
      this.modal = true;
    },
    openEdit(row) {
      this.$api.pro.inventory.billLoad(row.id).then(({data}) => {
        let d = data || {};
        d.direction = d.direction || 'IN';
        d.details = d.details || [];
        this.form = d;
        this.modal = true;
      });
    },
    addDetail() {
      this.form.details.push({materielId: null, spec: '', unit: '', qty: 0, price: 0, amount: 0});
    },
    removeDetail(i) {
      this.form.details.splice(i, 1);
    },
    onMaterialChange(data) {
      let m = this.stocks.find(s => s.id === data.materielId);
      if (m) {
        data.spec = m.spec;
        data.unit = m.unit;
      }
      this.calcAmount(data);
    },
    calcAmount(data) {
      let q = Number(data.qty) || 0;
      let p = Number(data.price) || 0;
      data.amount = (q * p).toFixed(2);
    },
    onSupplierChange(id) {
      let s = this.suppliers.find(x => x.id === id);
      this.form.supplierName = s ? s.name : '';
    },
    doSave() {
      if (!this.form.details.length) {
        this.$Message.warning('请添加明细');
        return;
      }
      for (let d of this.form.details) {
        if (!d.materielId) {
          this.$Message.warning('请选择存货');
          return;
        }
        if (!(Number(d.qty) > 0)) {
          this.$Message.warning('明细数量需大于 0');
          return;
        }
      }
      this.saving = true;
      let payload = Object.assign({}, this.form);
      payload.details = this.form.details.map(d => ({
        materielId: d.materielId, qty: d.qty, price: d.price, amount: d.amount
      }));
      //新增/编辑统一走 /inventory/bill，服务端按 id 自动分支（走 inventory-order 的 POST 只支持新增）
      let req = this.$api.pro.inventory.billSave(payload);
      req.then(() => {
        this.$Message.success('保存成功');
        this.modal = false;
        this.loadList();
      }).finally(() => this.saving = false);
    },
    doDelete(row) {
      this.$Confirm(`确认删除单据 ${row.code}？`).then(() => {
        this.$api.pro.inventory.billDel(row.id).then(() => {
          this.$Message.success('删除成功');
          this.loadList();
        });
      });
    },
    doGenerate() {
      this.$api.setting.inventoryOrder.preview(this.selectedIds).then(({data}) => {
        this.previewList = data || [];
        this.previewModal = true;
      });
    },
    confirmGenerate() {
      this.$api.setting.inventoryOrder.generate(this.selectedIds).then(({data}) => {
        this.$Message.success(data || '凭证生成成功');
        this.previewModal = false;
        this.loadList();
      });
    },
    openReceipt() {
      this.receipt = {billDate: new Date(), accountId: null, supplierId: null, amount: 0, summary: ''};
      this.receiptModal = true;
    },
    onReceiptSupplier(id) {
      let s = this.suppliers.find(x => x.id === id);
      this.receipt.supplierName = s ? s.name : '';
    },
    doSaveReceipt() {
      if (!this.receipt.accountId || !(Number(this.receipt.amount) > 0)) {
        this.$Message.warning('请选择收款账户并填写金额');
        return;
      }
      this.$api.pro.inventory.receiptSave(this.receipt).then(() => {
        this.$Message.success('收款单保存成功');
        this.receiptModal = false;
      });
    },
    doExport() {
      if (!this.list.length) {
        this.$Message.warning('没有可导出的数据');
        return;
      }
      let header = ['单据编号', '单据日期', '单据类型', '来源', '往来单位', '总金额', '总数量', '凭证状态'];
      let lines = this.list.map(r => [r.code, r.billDate, r.billTypeName, r.source, r.supplierName, r.amount, r.totalQty, r.voucherStatusText]);
      let csv = [header].concat(lines).map(a => a.map(v => `"${String(v == null ? '' : v).replace(/"/g, '""')}"`).join(',')).join('\n');
      let blob = new Blob(['\ufeff' + csv], {type: 'text/csv;charset=utf-8'});
      let url = URL.createObjectURL(blob);
      let a = document.createElement('a');
      a.href = url;
      a.download = '存货单据.csv';
      a.click();
      URL.revokeObjectURL(url);
    }
  },
  mounted() {
    this.loadOptions();
    this.loadList();
  }
};
</script>

<style lang="less" scoped>
.margin-top {
  margin-top: 10px;
}
.link {
  color: #2d8cf0;
  cursor: pointer;
  margin: 0 5px;
  &.danger {
    color: #ed4014;
  }
}
.voucher-title {
  margin: 10px 0;
  font-weight: bold;
}
</style>
